<div class="call-for-tender-container">
  <h1>{{ 'cft_list_title' | translate }}</h1>
  <div class="stats-container">
    <mat-card class="stat-card stat-card-success">
      <div class="stat-accent stat-accent-success"></div>
      <div class="stat-content">
        <div class="stat-header">
          <p class="stat-label">{{ 'cft_stat_tenders_created' | translate }}</p>
        </div>
        <div class="stat-footer">
          <p class="stat-value stat-success">{{ callForTendersCount }}</p>
        </div>
      </div>
    </mat-card>
    <mat-card class="stat-card stat-card-info">
      <div class="stat-accent stat-accent-info"></div>
      <div class="stat-content">
        <div class="stat-header">
          <p class="stat-label">{{ 'cft_stat_projects_created' | translate }}</p>
        </div>
        <div class="stat-footer">
          <p class="stat-value stat-info">{{ projectsCount }}</p>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="table-wrapper">
    <div class="create-row" (click)="onCreateClick()"><mat-icon>add</mat-icon> {{ 'cft_btn_create_tender' | translate }}</div>
    <ng-container *ngIf="displayedRows.length > 0; else emptyState">
      <div class="table-container">
        <app-table [columns]="columns" [rows]="displayedRows" [showDeleteAction]="true" (rowClick)="onRowClick($event)" (rowDelete)="onDeleteClick($event)" (sort)="onSort($event)"></app-table>
      </div>
      <div class="show-more-row" *ngIf="hasMoreRows" (click)="showMore()">{{ 'cft_show_more' | translate }}</div>
    </ng-container>
    <ng-template #emptyState>
      <div class="empty-state">
        <div class="empty-state-icon">
          <mat-icon>description</mat-icon>
        </div>
        <p class="empty-state-title">{{ 'cft_empty_state_title' | translate }}</p>
        <p class="empty-state-description">{{ 'cft_empty_state_description' | translate }}</p>
        <button mat-flat-button color="accent" class="empty-state-btn" (click)="onCreateClick()">
          <mat-icon>add</mat-icon>
          {{ 'cft_btn_create_tender' | translate }}
        </button>
      </div>
    </ng-template>
  </div>
  <img src="assets/img/call-for-tender-illustration.png" alt="Call for Tender Illustration" class="illustration" />
</div>
